const OCCUPATION = [
  'Self-Employed',
  'Salaried Private Sector',
  'Salaried Public Sector',
  'Business',
  'Professional',
  'Student',
  'Retired',
  'Housewife',
  'Not Working',
];
const INCOME = [
  '1-5 lakhs',
  '5 to 10 lakhs',
  '10 to 25 lakhs',
  '25-50 lakhs',
  '50 lakhs - 1 cr',
  '1cr - 5 cr',
  '5cr and above',
];

/**
 * Source: https://knowindia.india.gov.in/states-uts/
 */
const indianStatesAndUnionTerritories = [
  'Andaman and Nicobar Islands',
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chandigarh',
  'Chhattisgarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu & Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Ladakh',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
];

const DEPOSIT_BLOCKED_COUNTRIES_GLOBAL_EXCHANGE = ['uae', 'united arab emirates'];

export {
  OCCUPATION,
  INCOME,
  indianStatesAndUnionTerritories,
  DEPOSIT_BLOCKED_COUNTRIES_GLOBAL_EXCHANGE,
};
